<template>
    <div
        class="item-normal"
        v-if="itemStatus == 0"
        :class="{
      active: ifShowOption,
      showActions: itemShowActions == index,
      selected: beSelected.indexOf(item.o_id) !== -1
    }"
        @mouseenter="showOption($event)"
        @mouseleave="hideOption($event)"
        @click="linkOrSelect()"
    >
        <collapse>
            <file-closet
                v-show="index == itemShowActions"
                :actions="itemActions(item)"
                :type="item.type"
                :item="item"
                :caseNowIn="caseBelongIndex"
                @actionSelect="actionSelect"
                @moveToCase="moveToCase"
            ></file-closet>
        </collapse>
        <div class="option icon" @click.stop="showOptions(index)">&#xe98a;</div>
        <div class="item-title">
            <span
                class="icon"
                :class="{ graph: item.type == 'graph' }"
            >{{ item.type == "graph" ? "&#xe908;" : "&#xe9ac;" }}</span>
            <span :title="item.name">{{ item.name }}</span>
        </div>
        <div class="item-mask" v-if="editMode">
            <div class="checkbox"></div>
        </div>
        <div class="item-info">
            <span>
                {{
                item.type == "graph"
                ? `${$t("content.data-source")}:${item.dataSource}`
                : `${item.stockCode} ${item.companyName_cn}`
                }}
            </span>
            <span v-if="item.type == 'doc'">{{ item.companyName_en }}</span>
            <span class="last-saved">
                {{
                `${$t("content.last-save")} : ${item.lastSaved} `
                }}
            </span>
        </div>
        <div class="item-thumbnail" :style="{ 'background-image': `url(${item.img})` }"></div>

        <!-- lead to case -->
        <div
            class="find-case"
            v-if="showBadge"
            @mouseenter="showPopover(index)"
            @mouseleave="hidePopover"
        >
            <i class="icon">&#xe92d;</i>
            <popover v-if="nowHover == index" :caseName="caseBelong" @linkToCase="linkToCase"></popover>
        </div>
    </div>

    <!-- show tags or note -->
    <div class="item-tag-note" v-else>
        <div class="item-title">
            <span class="icon">&#xe95e;</span>
            <span>{{ itemStatus == 1 ? $t("content.tag") : $t("content.note") }}</span>
            <span class="return icon" @click.stop="backToNormal(index)">&#xe906;</span>
        </div>
        <div class="item-body">
            <div class="tag-space" v-if="itemStatus == 1">
                <span class="tag" v-for="(tag, index) in item.tags" :key="index" :title="tag">
                    <span>
                        <span></span>
                    </span>
                    <span class="text">{{tag}}</span>
                </span>
            </div>
            <ul class="note-space" v-else>
                <li
                    class="note"
                    v-for="(note, index) in item.notes"
                    :class="{ hidden: noteHidden[index] == 1 }"
                    :ref="`note`"
                    :key="index"
                >
                    <span class="text">{{ note }}</span>
                    <span
                        class="show-more"
                        v-if="noteHidden[index] !== 0"
                        @click="noteShowMore(index)"
                    >...{{ noteHidden[index] == 1 ? "MORE" : "LESS" }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import fileCloset from "@/components/fileCloset";
import { mapState, mapMutations, mapActions } from "vuex";
import popover from "@/components/popover";
import collapse from "@/components/transition";
export default {
    components: {
        popover,
        fileCloset,
        collapse
    },
    props: {
        index: {
            type: Number,
            default: 0
        },
        item: {
            type: Object,
            default() {
                return {};
            }
        },
        itemShowActions: {
            type: Number,
            default: -1
        },
        nowHover: {
            type: Number,
            default: -1
        }
    },
    computed: {
        ...mapState([
            "beSelected",
            "editMode",
            "allCases",
            "allItems",
            "tagBeSelected",
            "keyWord",
            "requestPending"
        ]),
        caseName() {
            let caseName = [];
            let cases = this.allCases;
            for (let i in cases) {
                caseName.push(cases[i].caseName);
            }
            return caseName;
        },
        indexInAllItems() {
            for (let i in this.allItems) {
                if (this.allItems[i]["o_id"] == this.item["o_id"]) {
                    return i;
                }
            }
        },
        caseBelong() {
            let caseOid = this.item["case_belong_id"];
            let now_case;
            for (let i in this.allCases) {
                if (this.allCases[i]["o_id"] == caseOid) {
                    now_case = this.allCases[i];
                }
            }
            return now_case.caseName;
        },
        caseBelongIndex() {
            let caseOid = this.item["case_belong_id"];
            for (let i in this.allCases) {
                if (this.allCases[i]["o_id"] == caseOid) {
                    return Number(i);
                }
            }
            return -1;
        },
        inCase() {
            return this.item["case_belong_id"];
        },
        showBadge() {
            return (
                this.item["case_belong_id"] &&
                (this.tagBeSelected.length !== 0 || this.keyWord !== "")
            );
        }
    },
    data() {
        return {
            itemStatus: 0,
            noteHidden: [],
            ifShowOption: false
        };
    },
    methods: {
        ...mapMutations([
            "select",
            "clearKeyword",
            "clearTagSelect",
            "clearSelect"
        ]),
        ...mapActions([
            "createCase",
            "moveItem",
            "itemMoveOut",
            "delete",
            "moveItemToNewCase",
            "getWorkSpace"
        ]),
        /**
         * create actionList depends on item type
         * @param {Object} item -item needs to show action list
         */
        itemActions(item) {
            let icon = {
                note: "\ue962",
                tag: "\ue95e",
                case: "\ue92d",
                delete: "\ue926",
                moveout: "\ue9ab"
            };
            let actions = {
                note: "action.view-note",
                tag: `action.view-tag`,
                case: "action.moveto",
                delete: "action.delete",
                moveout: "action.moveout"
            };
            let doc = ["note", "tag", "case", "delete"];
            let graph = ["case", "delete"];
            if (this.inCase) {
                doc.splice(3, 0, "moveout");
                graph.splice(1, 0, "moveout");
            }
            let itemActions = [];
            let type = item.type == "doc" ? doc : graph;
            for (let i in type) {
                let action = {};
                let key = type[i];
                action["icon"] = icon[key];
                action["action"] = actions[key];
                if (key == "case") {
                    action["next"] = true;
                    action["childList"] = this.caseName;
                }
                itemActions.push(action);
            }
            return itemActions;
        },
        linkOrSelect() {
            if (this.editMode) {
                this.select(this.item["o_id"]);
            } else {
                let url = this.item.url;
                window.open(url);
            }
        },
        showOption(e) {
            if (this.editMode) {
                return;
            }
            this.ifShowOption = true;
        },
        hideOption(e) {
            this.ifShowOption = false;
        },
        /**
         * @param {Number} index index of the active item
         */
        showOptions(index) {
            this.$emit("showActions", "item", index);
        },
        backToNormal() {
            this.itemStatus = 0;
        },
        /**
         * @param {Number} index index of the active item
         */
        showPopover(index) {
            this.$emit("showPopover", index);
        },
        hidePopover() {
            this.$emit("hidePopover");
        },
        /**
         * handle action selection
         * @param {Number} index index of the selected action
         */
        actionSelect(index) {
            this.hideOption();
            let action = this.itemActions(this.item)[index].action;
            this.$emit("hideActions");
            switch (action) {
                case "action.view-note":
                    if (this.item.notes.length !== 0) {
                        this.itemStatus = 2;
                    }
                    return;
                case "action.view-tag":
                    if (this.item.tags.length !== 0) {
                        this.itemStatus = 1;
                    }
                    return;
                case "action.moveout":
                    this.moveOut();
                    return;
                case "action.delete":
                    this.deleteItem();
            }
        },
        /**
         * move to case
         * @param {Number} index index of the target case
         */
        moveToCase(index) {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            if (index == this.caseBelongIndex && index !== -1) {
                return;
            } else {
                this.$emit("hideActions");
                this.hideOption();
                let payload = {};
                if (index < 0) {
                    this.moveToNewCase();
                } else {
                    let target_case = this.allCases[index].o_id;
                    payload["target_case"] = target_case;
                    this.select(this.item["o_id"]);
                    this.moveItem(payload)
                        .then(() => {
                            this.$toast();
                        })
                        .catch(() => {
                            this.$toast({ status: 1 });
                        });
                    this.$toast({ status: 2 });
                }
            }
        },
        moveToNewCase() {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            this.select(this.item["o_id"]);
            this.$dialog({ type: "dialog" });
            this.$fire.$on("caseName", (data, timestamp) => {
                if (data) {
                    this.moveItemToNewCase({ name: data, timestamp: timestamp })
                        .then(() => {
                            this.$toast();
                        })
                        .catch(() => {
                            this.$toast({ status: 1 });
                        });
                    this.$toast({ status: 2 });
                }
                this.$fire.$off("caseName");
            });
        },
        moveOut() {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            this.select(this.item["o_id"]);

            this.itemMoveOut()
                .then(() => {
                    this.$toast();
                })
                .catch(() => {
                    this.$toast({ status: 1 });
                });
            this.$toast({ status: 2 });
        },
        /**
         * show complete note
         * @param {index} index index of the note
         */
        noteShowMore(index) {
            if (this.noteHidden[index] == 1) {
                this.$set(this.noteHidden, index, 2);
            } else {
                this.$set(this.noteHidden, index, 1);
            }
        },
        routerHandle(path) {
            if (this.$curPath()[1] == "tag") {
                this.clearTagSelect();
                this.$nextTick(function() {
                    this.$router.replace(path);
                });
            } else if (this.$curPath()[0] == "search") {
                this.clearKeyword();
                this.$nextTick(function() {
                    this.$router.replace(path);
                });
            } else {
                this.$router.replace(path);
            }
        },
        /**
         * enter case when click case name on popover
         * @param {String} caseName
         */
        linkToCase(caseName) {
            this.hidePopover();
            this.routerHandle(`/case/${caseName}`);
        },
        deleteItem() {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            this.ifShowOption = false;
            this.$dialog({
                type: "confirm",
                name: this.item.name,
                title: "dialog.action-confirm"
            });
            this.$fire.$on("confirm", confirm => {
                if (confirm) {
                    this.select(this.item["o_id"]);

                    this.delete()
                        .then(() => {
                            this.$toast();
                        })
                        .catch(() => {
                            this.$toast({ status: 1 });
                        });
                    this.$toast({ status: 2 });
                }
                this.$fire.$off("confirm");
            });
        }
    },
    watch: {
        // calculate the height of note when choose view note
        // and if the note is take over 3 line ,push true into the noteHidden array
        itemStatus(val) {
            if (val == 2) {
                this.$nextTick(() => {
                    let noteHidden = [];
                    let note = this.$refs.note;
                    for (let i in note) {
                        let curNote = note[i];
                        if (curNote.offsetHeight >= 60) {
                            noteHidden.push(1);
                        } else {
                            noteHidden.push(0);
                        }
                    }
                    this.noteHidden = noteHidden;
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.item-normal,
.item-tag-note {
    position: relative;
    padding-top: 10px;
    margin: 12px 10px;
    width: 230px;
    height: 300px;
    border: 2px solid transparent;
    background: $base-color;
    box-shadow: 2px 3px 10px -4px rgba(13, 36, 60, 1);
    border-radius: 0px 4px 4px 4px;
    transition: all 500ms;
    cursor: pointer;
    & > .find-case {
        @include flex;
        position: absolute;
        background-color: $light-purple;
        width: 30px;
        height: 30px;
        border-top-left-radius: 4px;
        border-bottom-right-radius: 4px;
        right: -2px;
        bottom: -2px;
        transition: background-color 200ms;
        &:hover {
            background-color: $dark-purple;
        }
        & > i {
            color: $base-color;
        }
    }
    div.option {
        display: none;
    }
    &.active,
    &.showActions {
        box-shadow: 2px 3px 30px -10px rgba(13, 36, 60, 1);

        & > div.option {
            position: absolute;
            display: block;
            font-size: 26px;
            color: $light-purple;
            right: 8px;
            top: 8px;
            z-index: 100;
        }
    }
    .item-title {
        padding: 0 10px;
        height: 25px;
        padding-bottom: 5px;
        position: relative;
        & > span.icon {
            display: inline-block;
            font-size: 20px;
            width: 20px;
            height: 20px;
            color: #156ec9;
            &.graph {
                color: #fd9620;
            }
        }
        & > span:last-child {
            display: inline-block;
            color: $dark-purple;
            font-size: 16px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 160px;
        }
        &::after {
            @include after;
            height: 1px;
            width: 190px;
            background-color: $border-color;
            bottom: -1px;
            left: 10px;
        }
    }
    .item-thumbnail {
        height: 194px;
        overflow: hidden;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        & > img {
            width: 100%;
        }
    }
    .item-info {
        @include flex;
        padding: 4px 14px;
        justify-content: flex-start;
        flex-direction: column;
        align-items: flex-start;
        color: $dark-purple;
        font-size: 13px;
        height: 67px;
        & > span {
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
        }
        & > span.last-saved {
            color: #b8bbc2;
            font-size: 12px;
            margin-top: auto;
        }
    }
}
.item-tag-note {
    cursor: default !important;
    .item-title {
        @include flex;
        position: absolute;
        justify-content: flex-start;
        padding: 0;
        width: 230px;
        height: 36px;
        left: -2px;
        top: -2px;
        background-color: $light-purple;
        color: $base-color;
        font-size: 16px;
        border-top-right-radius: 4px;
        & > span.icon {
            text-align: center;
            color: $base-color;
            width: 30px;
        }
        & > .return {
            line-height: 20px;
            margin-left: auto;
            margin-right: 5px;
            border-radius: 4px;
            &:hover {
                background-color: $dark-purple;
            }
            &:active {
                background-color: $graph-color;
            }
        }
    }
    .item-body {
        margin-top: 26px;
        height: 249px;
        overflow-y: scroll;
        .tag-space {
            @include flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 5px 15px;
            .tag {
                cursor: default;
            }
        }
        .note-space {
            .note {
                position: relative;
                list-style: none;
                line-height: 20px;
                padding: 0 10px 0 18px;
                &.hidden {
                    height: 60px;
                    overflow: hidden;
                }
                .show-more {
                    position: absolute;
                    background: linear-gradient(
                        to left,
                        $base-color 60%,
                        rgba(254, 254, 254, 0)
                    );
                    color: $light-purple;
                    padding-right: 15px;
                    height: 20px;
                    font-size: 13px;
                    padding-left: 20px;
                    right: 0;
                    bottom: 0;
                    &:hover {
                        text-decoration: underline;
                    }
                    &:active {
                        text-decoration: underline;
                        color: $dark-purple;
                    }
                }
                &::before {
                    @include after;
                    width: 8px;
                    height: 8px;
                    top: 6px;
                    left: 5px;
                    background-color: #2c92ff;
                    border-radius: 50%;
                }
                .text {
                    display: inline-block;
                    color: $dark-purple;
                    font-size: 13px;
                    width: 100%;
                }
            }
        }
    }
}
.item-normal.selected {
    border-color: $light-purple;
    .checkbox {
        background-color: $light-purple;
        &::after {
            content: "\e99e";
            font-family: "gekko_fonts" !important;
            font-size: 18px;
            left: 6px;
            top: 6px;
            color: $base-color;
            position: absolute;
        }
    }
}
.item-mask {
    @include flex;
    position: absolute;
    left: -2px;
    bottom: -2px;
    width: 230px;
    height: 198px;
    background: rgba(21, 110, 201, 0.4);
    border-radius: 0px 0px 4px 4px;
    .checkbox {
        width: 30px;
        height: 30px;
        border: 1px solid $light-purple;
        border-radius: 4px;
        cursor: pointer;
        background-color: $base-color;
        transition: all 300ms;
        position: relative;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/itemCard.vue